import { render } from "./HeaderPages.vue?vue&type=template&id=5efced0e&bindings={\"language\":\"setup\",\"lang\":\"data\",\"siteroot\":\"data\",\"checkToEspandNavbar\":\"options\",\"getUrlLogout\":\"options\"}"
import script from "./HeaderPages.vue?vue&type=script&lang=js"
export * from "./HeaderPages.vue?vue&type=script&lang=js"

import "./HeaderPages.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script